export default __webpack_public_path__ + "8a6deb75ac738424d695478c6b8af89c.jpg";